/* eslint-disable */
export enum FinnairBoundNote {
  HAS_NEXT_DAY_TRANSFER = 'HAS_NEXT_DAY_TRANSFER',
  REQUIRES_AIRPORT_CHANGE = 'REQUIRES_AIRPORT_CHANGE',
  DISRUPTION_CHANGE = 'DISRUPTION_CHANGE',
  DISRUPTION_TIME_CHANGE = 'DISRUPTION_TIME_CHANGE'
}

